import React from "react";

import { ALARMS_TABLE_STRINGS, InputErrorStrings } from "constants/constantStrings";

import DupontCheckbox from "components/DupontCheckbox";

import InputBox from "../../../components/InputBox";

export default function AlarmListEditForm(props) {
  const {
    selectedAlarmDetails,
    onInputChange,
    onSendAlertChange,
    onShowReportChange,
    alarmNameError,
    alarmDescError,
    onAlarmMaxDescriptionLimit,
    onAlarmNameMaxLimit
  } = props;

  return (
    <>
      <div className="column">
        <InputBox
          labelText={`${ALARMS_TABLE_STRINGS.headerAlarmID}*`}
          name="AlarmID"
          value={selectedAlarmDetails.AlarmID}
          disabled={true}
          customClass="form-group"
        />
        <InputBox
          labelText={`${ALARMS_TABLE_STRINGS.headerAlarmDesc}*`}
          name="Description"
          value={selectedAlarmDetails.Description}
          onChange={onInputChange}
          requiredMsg={InputErrorStrings.required}
          customClass="form-group"
          maxLength={500}
          errorMsg={alarmDescError}
          onMaxLengthReached={onAlarmMaxDescriptionLimit}
        />
      </div>
      <div className="column">
        <InputBox
          labelText={`${ALARMS_TABLE_STRINGS.headerAlarmName}*`}
          name="AlarmName"
          value={selectedAlarmDetails.AlarmName}
          onChange={onInputChange}
          requiredMsg={InputErrorStrings.required}
          customClass="form-group"
          maxLength={100}
          errorMsg={alarmNameError}
          onMaxLengthReached={onAlarmNameMaxLimit}
        />
        <div className="form-group alarm-list-edit-checkbox__container">
          <DupontCheckbox
            checked={selectedAlarmDetails.SendAlert}
            name="SendAlert"
            onChange={onSendAlertChange}
            labelText={ALARMS_TABLE_STRINGS.headerAlarmAlert}
            customClass="descriptionText alarm-list-edit__checkbox"
          />
          <DupontCheckbox
            checked={selectedAlarmDetails.ShowInReport}
            name="ShowInReport"
            onChange={onShowReportChange}
            labelText={ALARMS_TABLE_STRINGS.headerAlarmAddToReport}
            customClass="descriptionText alarm-list-edit__checkbox"
          />
        </div>
      </div>
    </>
  );
}
